import React from "react";
import { graphql } from "gatsby";
import { FiftyFiftyFeaturedContent } from "./FiftyFiftyFeaturedContent";
import {
  KontentLinks,
  KontentLinkedMediaImage,
  KontentMultiChoice,
  KontentRichText,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatLinks } from "../../../lib/links";
import { getImage } from "gatsby-plugin-image";
import { formatImages } from "../../../lib/images";

interface Props {
  orientation: KontentMultiChoice<"text_left" | "text_right">;
  style: KontentMultiChoice<"green_background" | "cream_background">;
  text_alignment: KontentMultiChoice<"left" | "center">;
  content_category_tax: KontentMultiChoice<string>;
  subhead: StringValue;
  date_time: StringValue;
  text: KontentRichText;
  link_configuration__link: KontentLinks;
  image: KontentLinkedMediaImage;
  component_settings__anchor_name: StringValue;
  component_settings__hide_on_mobile: KontentMultiChoice<"yes" | "no">;
  component_layout__component_width: KontentMultiChoice<"full" | "contained">;
  id: string;
}

const FiftyFiftyFeaturedContentContainer: React.FC<Props> = ({
  orientation,
  style,
  text_alignment,
  content_category_tax,
  subhead,
  date_time,
  text,
  link_configuration__link,
  image,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  component_layout__component_width,
  id,
}) => {
  return (
    <FiftyFiftyFeaturedContent
      orientation={getMultiChoice(orientation) || "text_left"}
      style={getMultiChoice(style) || "cream_background"}
      textAlignment={getMultiChoice(text_alignment) || "left"}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      width={getMultiChoice(component_layout__component_width)}
      contentCategory={content_category_tax?.value[0]?.name}
      subhead={subhead.value}
      dateTime={date_time.value}
      text={text}
      ctas={formatLinks(link_configuration__link?.modular_content).slice(0, 4)}
      image={formatImages(image?.value[0]?.elements).largeImage}
      id={id}
    ></FiftyFiftyFeaturedContent>
  );
};

export default FiftyFiftyFeaturedContentContainer;

export const fragmentFiftyFiftyFeaturedContent = graphql`
  fragment FiftyFiftyFeaturedContent on kontent_item_component___5050_featured_content {
    elements {
      orientation {
        value {
          codename
        }
      }
      style {
        value {
          codename
        }
      }
      text_alignment {
        value {
          codename
        }
      }
      content_category_tax {
        value {
          name
        }
      }
      subhead {
        value
      }
      date_time {
        value(formatString: "dddd, MMMM D, YYYY | h:mm A")
      }
      text {
        value
      }
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      image {
        value {
          ...kontentMediaImage
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
